import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { subCategoryList } from 'ggApp/modules/category/selectors';
import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';

import SearchSuggestions from './SearchSuggestions';

const enhance = compose(
    withDeviceInfo,
    connect(
        createStructuredSelector({
            subCategories: subCategoryList,
        }),
    ),
    withProps(({ subCategories }) => ({
        subCategoryNames: subCategories.map((subCategory) => subCategory.name),
    })),
    withProps(({ userDevice }) => ({
        isMobileUser: userDevice === 'mobile',
    })),
);

export default enhance(SearchSuggestions);
